import { Button, IconButton, Stack, Tooltip } from '@mui/material';
import styles from './ActionButtons.module.scss';
import AISummaryIcon from '../../../../../assets/svg/list_alt_check.svg?react';
import FileSaveIcon from '../../../../../assets/svg/file_save.svg?react';
import BrushIcon from '../../../../../assets/svg/brush.svg?react';
import EditContractIcon from '../../../../../assets/svg/contract_edit.svg?react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ActionButtonsProps } from './types';
import { DocumentsEditButton } from '../../../../common/document-edit-button/DocumentsEditButton';
//import { useSearchParams } from 'react-router-dom';
import { useAppSelector } from '../../../../common/hooks/useAppSelector';
import { selectUserRoleByGroupName } from '../../../../slices/user/userSlice';
import { GROUPS } from '../../../../common/constants/groups';
import { Document } from '../../../document-vault/components/document-list-vault/types';

export const ActionButtons = ({
  handleAISummaryGeneration,
  isImage,
  handleDocumentDownload,
  handleSignDocument,
  handleEditDocument,
  //handleCreateTemplate,
  handleDeleteDocument,
  handleSaveDocument,
  buttonSaveDisabled,
  //handleCreateTemplateMainBtn,
  doc,
  //creatingTemplateEnabled,
  isDocumentContentTab,
  setEditingDocument,
}: ActionButtonsProps) => {
  const { t } = useTranslation();
  //const [params] = useSearchParams();
  const userIsEmployee = Boolean(
    useAppSelector(selectUserRoleByGroupName(GROUPS.COMPANY_EMPLOYEE))
  );
  //const contractGenerated = params.get('contractGenerated');
  //const editDocumentParam = params.get('editDocument');
  return (
    <Stack
      sx={{
        flexDirection: 'row',
        justifyContent: { md: 'flex-end' },
        flexShrink: 0,
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '6px',
      }}
    >
      {/*handleCreateTemplateMainBtn &&
        !creatingTemplateEnabled &&
        handleCreateTemplate &&
        !isImage && (
          <>
            {userIsEmployee ? (
              <Tooltip title={t('messages.contactAdministrator')} placement='top' arrow>
                <Button
                  id='actionButtonsCreateTemplateBtn'
                  type='button'
                  className='btn-default btn-action-basic btn-small'
                  role='button'
                  variant='contained'
                  onClick={undefined}
                  disabled={true}
                  style={{ marginRight: '8px' }}
                >
                  {t('buttons.createTemplate')}
                </Button>
              </Tooltip>
            ) : (
              <Button
                id='actionButtonsCreateTemplateBtn2'
                type='button'
                className='btn-action-basic btn-primary-action btn-small'
                role='button'
                variant='contained'
                disabled={!buttonSaveDisabled}
                onClick={handleCreateTemplate}
                style={{ marginRight: '8px' }}
              >
                {t('buttons.createTemplate')}
              </Button>
            )}
          </>
        )*/}
      {Boolean(handleSaveDocument) && !buttonSaveDisabled && isDocumentContentTab && (
        <Button
          id='actionButtonsCancelBtn'
          type='button'
          className='btn-default btn-action-basic btn-cancel btn-small'
          role='button'
          variant='contained'
          disabled={buttonSaveDisabled}
          onClick={() => setEditingDocument(false)}
        >
          {t('buttons.cancel')}
        </Button>
      )}
      {Boolean(handleSaveDocument) && !buttonSaveDisabled && isDocumentContentTab && (
        <Button
          id='actionButtonsSaveContentBtn'
          type='button'
          className='btn-default btn-action-basic btn-small'
          role='button'
          variant='contained'
          disabled={buttonSaveDisabled}
          onClick={handleSaveDocument}
        >
          {t('buttons.saveContent')}
        </Button>
      )}
      {(!isDocumentContentTab || buttonSaveDisabled) &&
        doc &&
        !isImage &&
        !doc?.is_flattened &&
        'contract_generation' in doc && (
          <Tooltip
            title={userIsEmployee ? t('messages.contactAdministrator') : t('buttons.edit')}
            placement='top'
            arrow
          >
            <IconButton
              id='actionButtonsEditIconBtn'
              size='small'
              className={styles.actionButton}
              disabled={userIsEmployee /*|| creatingTemplateEnabled*/}
              onClick={userIsEmployee ? undefined : handleEditDocument}
            >
              <BrushIcon id='actionButtonsEditIconBtnBrushIcon' />
            </IconButton>
          </Tooltip>
        )}
      {handleSignDocument && !isImage && !doc?.is_flattened && (
        <Tooltip
          title={
            userIsEmployee
              ? t('messages.contactAdministrator')
              : doc &&
                  'du_filetype' in doc &&
                  doc?.du_filetype &&
                  doc?.du_filetype.length > 0 &&
                  doc?.du_filetype[0] !== 'pdf' &&
                  !(doc && 'contract_generation' in doc)
                ? t('messages.convertToPDFMessage')
                : t('buttons.sign')
          }
          placement='top'
          arrow
        >
          <IconButton
            id='actionButtonsSignIconBtn'
            size='small'
            className={styles.actionButton}
            onClick={
              doc &&
              'du_filetype' in doc &&
              doc?.du_filetype &&
              doc?.du_filetype.length > 0 &&
              doc?.du_filetype[0] !== 'pdf' &&
              !(doc && 'contract_generation' in doc)
                ? undefined
                : handleSignDocument
            }
          >
            <EditContractIcon id='actionButtonsSignIconBtnEditContractIcon' />
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title={t('buttons.download')} placement='top' arrow>
        <IconButton
          id='actionButtonsDownloadIconBtn'
          size='small'
          className={styles.actionButton}
          onClick={handleDocumentDownload}
        >
          <FileSaveIcon id='actionButtonsDownloadIconBtnFileSaveIcon' />
        </IconButton>
      </Tooltip>
      {!isImage && (
        <Tooltip title={t('buttons.summary')} placement='top' arrow>
          <IconButton
            id='actionButtonsSummaryIconBtn'
            size='small'
            className={styles.actionButton}
            onClick={handleAISummaryGeneration}
          >
            <AISummaryIcon id='actionButtonsSummaryIconBtnAiSummaryIcon' />
          </IconButton>
        </Tooltip>
      )}
      {!isImage && !doc?.is_flattened && (
        /*editDocumentParam &&*/ <DocumentsEditButton
          document={doc as Document}
          createTemplateFn={undefined /*!contractGenerated ? handleCreateTemplate : undefined*/}
          deleteDocumentFn={handleDeleteDocument}
        />
      )}
    </Stack>
  );
};
